import React from 'react'

const PastOrders = () => {
  return (
    <div>
      
    </div>
  )
}

export default PastOrders
